import { render, staticRenderFns } from "./BuilderSiteSettings.vue?vue&type=template&id=481de2fd&scoped=true&"
import script from "./BuilderSiteSettings.vue?vue&type=script&lang=js&"
export * from "./BuilderSiteSettings.vue?vue&type=script&lang=js&"
import style0 from "./BuilderSiteSettings.vue?vue&type=style&index=0&id=481de2fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481de2fd",
  null
  
)

export default component.exports